import {
    PROJECT_LIST_REQUEST,
    PROJECT_LIST_RESPONSE,
    PROJECT_LIST_CACHED_RESPONSE,
    PROJECT_LIST_ERROR_RESPONSE
} from "../actions/action-types"

import {
    projectListResponse,
    projectListCachedResponse,
    projectListErrorResponse
} from "../actions/project-actions"

import {
    requestListEpic,
    callbackActionCreatorEpic
} from "./default-epics/default-entity-epics"

import { getProjectList } from "../api/project-api"

export const requestProjectListEpic = requestListEpic(
    PROJECT_LIST_REQUEST,
    getProjectList,
    "projects",
    projectListResponse,
    projectListCachedResponse,
    projectListErrorResponse
)

export const responseUserCallbackEpic = callbackActionCreatorEpic(
    PROJECT_LIST_RESPONSE,
    PROJECT_LIST_CACHED_RESPONSE,
    PROJECT_LIST_ERROR_RESPONSE
)
